import config from "config/config";
import { getActiveAgent } from "./getActiveAgent";

export const getWritingAgents = (policy) => {
  const writingAgents =
    config.ENABLE_SHOWING_WRITING_AGENT === "true" &&
    policy?.agents?.filter((agent) => agent.agentType === "Writing Agent");

  return getActiveAgent(writingAgents, policy);
};
